// src/app/core/interceptors/otp.interceptor.ts
import { HttpErrorResponse, HttpContext, HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { OtpSessionService } from '../services/otp/otp-session.service';
import { OtpChallengeService } from '../services/otp/otp-challenge.service';

export const OTP_FEATURE = new HttpContextToken<string | null>(() => null);
export function withOtpFeature(feature: string): HttpContext {
  return new HttpContext().set(OTP_FEATURE, feature);
}

export const otpInterceptor: HttpInterceptorFn = (req, next) => {
  const otpSessionService = inject(OtpSessionService);
  const otpChallengeService = inject(OtpChallengeService); // <-- no more ModalController chain

  const feature = req.context.get(OTP_FEATURE);

  let outgoing = req;
  if (feature) {
    const session = otpSessionService.getLocalSession(feature);
    const deviceId = otpSessionService.getDeviceId();
    const existingBody = (req.body ?? {}) as Record<string, unknown>;

    outgoing = req.clone({
      body: {
        ...existingBody,
        financeSessionToken: session?.sessionToken ?? null,
        deviceId
      }
    });
  }

  return next(outgoing).pipe(
    catchError((err: HttpErrorResponse) => {
      if (feature && err.status === 403 && err.error?.error === '2FA_REQUIRED') {
        otpSessionService.clearSession(feature);
        return from(otpChallengeService.requestChallenge(feature)).pipe(
          switchMap(() => next(outgoing))
        );
      }
      return throwError(() => err);
    })
  );
};